import { Loadable } from 'components/common';
import { OmniHistoriesProvider } from 'contexts';
import React, { useRef } from 'react';
import { ChatSessionDto } from 'types';
import OmniChannelLeadChatHistoriesChat from './OmniChannelLeadChatHistoriesChat';
import { useDivWidth } from 'utils/layout';

type Props = {
  chatSession: ChatSessionDto;
};
const OmniChannelLeadChatHistoriesChatBox: React.FC<Props> = ({ chatSession }) => {
  const ref = useRef<HTMLDivElement>(null);
  const chatBoxWidth = useDivWidth(ref);

  return (
    <div ref={ref}>
      {chatBoxWidth > 0 && (
        <Loadable>
          <OmniHistoriesProvider
            key={chatSession.chatSessionId + chatSession.chatId + chatBoxWidth}
            isRead={false}
            endpointName={'history-chat-sessions'}
            chatSession={chatSession}
            variables={{
              systemMessText: '#ffff'
            }}
            isShowName={false}
            chatBoxWidth={chatBoxWidth * 0.7}
          >
            <OmniChannelLeadChatHistoriesChat />
          </OmniHistoriesProvider>
        </Loadable>
      )}
    </div>
  );
};
export default OmniChannelLeadChatHistoriesChatBox;
